import { render } from "./clientsNumbers.vue?vue&type=template&id=3ad96c9c"
import script from "./clientsNumbers.vue?vue&type=script&lang=js"
export * from "./clientsNumbers.vue?vue&type=script&lang=js"

import "./clientsNumbers.vue?vue&type=style&index=0&id=3ad96c9c&lang=css"

import exportComponent from "C:\\Users\\Luis\\Documents\\Anfisbena\\Projects\\crm\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__